import styled from 'styled-components'
import Colors from '../constants/colors'

export const PanelsContainer = styled.div`
  margin-top: -120px;
  margin-bottom: 40px;
  display: flex;
  align-items: stretch;
  max-width: 1320px;
  @media (max-width: 1000px) {
    margin-top: -40px;
    flex-direction: column;
    align-items: initial;
  }
  @media (max-width: 425px) {
    margin-top: 10px;
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
  .column {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 30%;
    display: flex;
    flex-direction: column;
     /* TODO: убрать height, когда раскоментишь данные в колонке */
    height: fit-content;
  }
`

export const Panel = styled.div`
  flex-grow: 1;
  margin: 12.5px 15px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  font-family: StolzlLight;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0px;
  @media (max-width: 1000px) {
    margin: 10px 40px;
  }
  @media (max-width: 425px) {
    margin: 10px 30px;
  }
  .panelContent {
    display: flex;
    flex-direction: column;
    padding: 30px 50px;
    @media (max-width: 1000px) {
      padding: 40px;
    }
    @media (max-width: 425px) {
      padding: 25px;
    }
    a {
      font-size: 14px;
      color: ${Colors.primary};
      :hover {
        text-decoration: none;
      }
    }
    .link {
      color: #000;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition-duration: 0.2s;
      text-decoration: none;
      &:hover {
        color: ${Colors.primary};
      }
      .icon {
        margin-right: 13px;
        transition-duration: 0.2s;
        color: ${Colors.secondaryHover};
      }
    }
    .press {
      text-decoration: underline;
    }
  }
  .button {
    margin-top: 35px;
    justify-content: center;
    a {
      width: 100%;
      max-width: 300px;
      color: #fff;
      &:hover {
        color: ${Colors.primary};
      }
    }
  }
  h2 {
    text-transform: uppercase;
    @media (max-width: 425px) {
      font-size: 16px;
      line-height: 30px;
      letter-spacing: 2px;
    }
  }
  .name {
    margin-top: 10px;
    @media (max-width: 425px) {
      margin-top: 8px;
      font-size: 14px;
      line-height: 22px;
      letter-spacing: 0px;
    }
  }
  .text {
    margin-top: 30px;
    @media (max-width: 425px) {
      margin-top: 15px;
    }
  }
  .timeText {
    display: flex;
    align-items: center;
    margin-top: 12.5px;
    padding-top: 12.5px;
    border: 0px solid #d2dae4;
    border-top-width: 1px;
    img {
      margin-right: 18px;
      height: 30px;
    }
    &--no-border {
      border: none;
      padding-top: 5px;
    }
  }
  .date {
    color: ${Colors.primary};
  }
  .innerPanel {
    margin: 10px 25px;
    padding: 15px 25px;
    border-radius: 10px;
    box-shadow: 0 1px 6px 1px rgba(186, 186, 186, 0.2);
    border: solid 1px #ffffff;
    @media (max-width: 1000px) {
      box-shadow: none;
      padding: 0px;
      margin: 40px;
      margin-top: 0px;
      .label:first-of-type {
        margin-top: 0px;
      }
    }
    @media (max-width: 425px) {
      margin: 25px;
      margin-top: 0px;
    }
    .label {
      font-family: StolzlMedium;
    }
    .location {
      display: flex;
      padding-top: 13px;
      img {
        margin-right: 13px;
        width: 40px;
        height: 40px;
      }
    }
  }
`

export const Line = styled.div`
  margin-top: 10px;
  @media (max-width: 425px) {
    margin-top: 8px;
    line-height: 22px;
    letter-spacing: 0px;
  }
`
